module.exports = require("core-js-pure/features/array/is-array");


// WEBPACK FOOTER //
// webpack://idx/node_modules/@babel/runtime-corejs3/core-js/array/is-array.js